import { gql } from '@apollo/client';

/**
 * 「大包差异」tab 第三级展开：MAWB 下的单个大包行。
 * 每行返回 (bagNumber, arrivalDate?, isInbound)；未入库时 arrivalDate 为 null。
 */
export const GET_WORK_PROGRESS_BAG_DIFF_MAWB_BAG_SUMMARIES = gql`
  query GetWorkProgressBagDiffMawbBagSummaries($filter: WorkProgressBagDiffMawbBagSummaryFilterInput!) {
    getWorkProgressBagDiffMawbBagSummaries(filter: $filter) {
      bagNumber
      arrivalDate
      isInbound
      scanTime
    }
  }
`;

export interface WorkProgressBagDiffMawbBagSummaryFilterInput {
  prePickupHubId: number;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  customerId: number;
  mawb: string;
}

export interface WorkProgressBagDiffMawbBagSummaryRow {
  bagNumber: string;
  arrivalDate: string | null;
  isInbound: boolean;
  /** client_carton.scan_time（ISO-8601 UTC），与下钻 drawer 同源；未匹配到为 null */
  scanTime: string | null;
}

export interface GetWorkProgressBagDiffMawbBagSummariesResponse {
  getWorkProgressBagDiffMawbBagSummaries: WorkProgressBagDiffMawbBagSummaryRow[];
}
